import r from"../internals/export.js";import s from"../internals/object-assign.js";var a=r,t=s;a({target:"Object",stat:!0,arity:2,forced:Object.assign!==t},{assign:t});
